import { BusinessType } from '../../../../data-layer/business/types';

export const getBusinessType = (query: URLSearchParams, isBloggerEnabled: boolean) =>
    (query.get('type') === BusinessType.BLOGGER && isBloggerEnabled
        ? BusinessType.BLOGGER
        : BusinessType.BUSINESS) as BusinessType;
